import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/Header";

import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';
import Select1 from './imgs/select1@2x.png';
import Select2 from './imgs/select2@2x.png';
import Select2Disabled from './imgs/select-disabled@2x.png';
import bwmodel from '@/config/bwmodel'
import Star from './imgs/star@2x.png';
import ModalTips from './components/modal-tips';

import { initGame } from './api';

import store from '@/redux';
import { activityShare, isStorm, handleUploadTrace } from './stock';

const Page1 = ({ next, setUniqueCode = '', activityInfo, setMode }) => {

  const token = store.getState().user ? store.getState().user.accessToken : '';
  const isLogin = !!token;
  const modalRef = useRef();

  const nickname = activityInfo.user ? activityInfo.user.nickname : '';

  useEffect(() => {
    handleUploadTrace('select', 'visitor')
  }, [])

  const handleSelectMode = (mode) => {
    if (mode === 1) {
      handleUploadTrace('select-fast', 'click')
    } else {
      handleUploadTrace('select-train', 'click')
    }
    

    if (mode === 2 && !isStorm) {
      modalRef.current.show({
        content: '股神模式仅限在市值风云APP使用'
      })
      return;
    }
    initGame({mode: mode === 1 ? 'fast' : 'trading'}).then(res => {
      setUniqueCode(res.uniqueCode || '');
      setMode(res.mode);
      next();
    });
  }

  return (
    <Container>
      {
        isStorm &&
        <Header
          title="重生之股神模拟器"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />

          <img src={Star} alt='' className="star-img star-img1"/>
          <img src={Star} alt='' className="star-img star-img2"/>
          <img src={Star} alt='' className="star-img star-img4"/>
          <img src={Star} alt='' className="star-img star-img5"/>
          <img src={Star} alt='' className="star-img star-img6"/>
          
          <div className="user-card">
            {isLogin && <div className="user-name">Hi {nickname}</div>}
            <div className="user-text">请选择穿越模式</div>
          </div>

          <div className="select-wrap">
            <div className="select-img-wrap">
              <img onClick={() => handleSelectMode(1)} src={Select1} alt='' className="select-img" />
            </div>
            <div className="select-img-wrap select-img-wrap2">
              <img onClick={() => handleSelectMode(2)} src={!isStorm ? Select2Disabled : Select2} alt='' className="select-img" />
            </div>
          </div>
        </div>
      </div>
      <ModalTips ref={modalRef}/>
    </Container>
  );
}

export default React.memo(Page1);

const Container = styled.div`
.page-content {
  .star-img {
    position: absolute;
    z-index: 10;
  }
  .star-img1 {
    width: 38px;
    height: 38px;
    top: 50px;
    left: 188px;
  }
  .star-img2 {
    width: 32px;
    height: 32px;
    top: 20px;
    right: 10px;
  }
  .star-img4 {
    width: 41px;
    height: 41px;
    top: 330px;
    right: 2px;
  }
  .star-img5 {
    width: 49px;
    height: 49px;
    left: 10px;
    bottom: 73.5px;
  }
  .star-img6 {
    width: 32px;
    height: 32px;
    top: 300px;
    left: 10px;
  }
}
.user-card {
  color: #EAC5A9;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 28px;
  margin-top: 22px;
  .user-name {
    font-size: 17px;
    font-weight: 500;
    line-height: 17px;
  }
  .user-text {
    font-size: 19px;
    font-weight: 600;
    line-height: 19px;
    margin-top: 8px;
  }
}
.select-wrap {
  margin-top: 21px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .select-img-wrap {
    width: 314px;
    height: 230px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .select-img {
      width: 100%;
      height: 100%;
    }
  }
  .select-img-wrap2 {
    width: 314px;
    height: 236px;
  }
}
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/page1.js